import { SESSION } from '../actions/cookiesAction';

export const cookieState = {
    session: '',
};
export const cookieReducer = (state = cookieState, action) => {
    switch (action.type) {
        case SESSION:
            return { ...state, session: action.data };
        default:
            return state;
    }
};
